{{#each this}}
	<div><a href class="remove-quiz" data-index="{{@index}}"><i class="icon-remove"></i></a> {{this}}</div>
{{/each}}
<select class="quiz-pages"></select>
<button class="button add-quiz" style="display: inline; margin-top: 0; margin-bottom: 10px;"><i class="icon-plus"></i></button>
